import { AppInfo } from '../../../../../../constants';

export const USER_ACTIVE_ROLE_ID_STORAGE_KEY = `${AppInfo.companyName}-active-role`;
